module.exports = __webpack_public_path__ + "img/analogue-italic-webfont.032ffce.svg";